export const TALON_INITIAL_VALUE = '{"version": 5, "status": -1}';
export const getTalonInitialValue = () => {
  return TALON_INITIAL_VALUE;
};